import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import footerStyles from "../Styles/footer.module.css"

const Footer = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
          }
        }
      }
    `
  )
  return (
    <footer className={footerStyles.footer}>
      <p>
        Página creada por {data.site.siteMetadata.author} ©{` `}
        {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://www.gatsbyjs.org">Gatsby</a>
      </p>
    </footer>
  )
}

export default Footer
